import { ReactComponent as Tele2AltelLogo } from 'assets/img/content/operator/tele2_altel.svg';
import { ReactComponent as KcellActiveLogo } from 'assets/img/content/operator/kcell_active.svg';
import { ReactComponent as BeelineLogo } from 'assets/img/content/operator/beeline.svg';

export const OPERATORS = [
  {
    key: 'tele2Altel',
    component: Tele2AltelLogo
  },
  {
    key: 'kcellActive',
    component: KcellActiveLogo
  },
  {
    key: 'beeline',
    component: BeelineLogo
  }
];
